var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useRepositories } from '../../../contexts';
import { useStorage } from '../../../contexts/StorageContext/useStorage';
import { StorageKeys } from '../../../services';
import { InvalidationTag, LoaderType, useAppQuery } from '../utils';
export var useGetCustomerApi = function (isEnabled, loader, keepPreviousData) {
    if (isEnabled === void 0) { isEnabled = true; }
    if (loader === void 0) { loader = LoaderType.None; }
    if (keepPreviousData === void 0) { keepPreviousData = false; }
    var customerRepo = useRepositories().customerRepo;
    var queryClient = useQueryClient();
    var storage = useStorage();
    var _a = useState(undefined), placeholderData = _a[0], setPlaceholderData = _a[1];
    // Carica placeholderData dalla cache o dallo storage PRIMA che la query parta
    // CRITICO: Carica placeholderData SOLO se isEnabled = true E c'è un token valido
    // Questo previene che customer venga ripristinato quando l'utente non è autenticato
    useEffect(function () {
        var loadPlaceholderData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var accessToken, cachedCustomer, storedCustomerStr, storedCustomer, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, storage.getItem(StorageKeys.ACCESS_TOKEN_KEY)];
                    case 1:
                        accessToken = _a.sent();
                        if (!accessToken) {
                            // Non c'è token, quindi l'utente non è autenticato - NON caricare placeholderData
                            setPlaceholderData(undefined);
                            return [2 /*return*/];
                        }
                        cachedCustomer = queryClient.getQueryData([
                            InvalidationTag.Customer,
                        ]);
                        if (cachedCustomer) {
                            setPlaceholderData(cachedCustomer);
                            return [2 /*return*/];
                        }
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, storage.getItem(StorageKeys.CUSTOMER)];
                    case 3:
                        storedCustomerStr = _a.sent();
                        if (storedCustomerStr) {
                            storedCustomer = JSON.parse(storedCustomerStr);
                            setPlaceholderData(storedCustomer);
                            // Ripristina anche nella cache per coerenza
                            queryClient.setQueryData([InvalidationTag.Customer], storedCustomer);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        if (isEnabled) {
            loadPlaceholderData();
        }
        else {
            // Se isEnabled = false, resetta placeholderData per sicurezza
            setPlaceholderData(undefined);
        }
    }, [isEnabled, queryClient, storage]);
    var getCustomer = useAppQuery([InvalidationTag.Customer], function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, customerRepo.getCustomer()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    }); }, {
        enabled: isEnabled,
        keepPreviousData: keepPreviousData,
        placeholderData: placeholderData,
    }, loader);
    return getCustomer;
};
